import { render } from "./ShopPage.vue?vue&type=template&id=fafb754a&scoped=true"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ShopPage.vue?vue&type=style&index=0&id=fafb754a&module=true&lang=css"
cssModules["$style"] = style0
import "./ShopPage.vue?vue&type=style&index=1&id=fafb754a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-fafb754a"]])

export default __exports__